import BaseService from "./Base.Service";

class QuizAnswerService extends BaseService {
	constructor() {
		super("quiz-answers");
	}

	// Envia as respostas com a mensagem do back no erro ("Você já respondeu…").
	// Em erro, o toast sai aqui e volta { error: true }.
	async send(data) {
		try {
			const response = await this.conn.axios.post(`/quiz-answers`, data);
			return response.data;
		} catch (err) {
			return this.sendError("Erro ao enviar as respostas", false, err);
		}
	}
}

export default QuizAnswerService;
